// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum StepperMutationTypes {
    SET_STEP_VEHICLE_DETAILS = 'SET_STEP_VEHICLE_DETAILS',
    SET_STEP_DRIVER_DETAILS = 'SET_STEP_DRIVER_DETAILS',
    SET_STEP_COMPARE_QOUTES = 'SET_STEP_COMPARE_QOUTES',
    SET_STEP_YOUR_COVER = 'SET_STEP_VEHICLE_DETAILS'
  }
  